import ListPage from './ListPage';
import CreatePage from './CreatePage.container';
import EditPage from './EditPage.container';

export default { ListPage, CreatePage, EditPage };
